import React from 'react';
import './StatCard.css';

interface StatCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon?: string | React.ReactNode;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  color = 'primary',
  onClick
}) => {
  const cardClassName = `stat-card stat-card-${color} ${onClick ? 'stat-card-clickable' : ''}`;

  return (
    <div className={cardClassName} onClick={onClick}>
      <div className="stat-card-content">
        <div className="stat-card-left">
          <h3 className="stat-card-title">
            {icon && (
              <span className="stat-card-icon">
                {typeof icon === 'string' ? icon : icon}
              </span>
            )}
            {title}
          </h3>
          {subtitle && <div className="stat-card-subtitle">{subtitle}</div>}
        </div>
        <div className="stat-card-right">
          <div className="stat-card-value">{value}</div>
        </div>
      </div>
      {onClick && <div className="stat-card-arrow">→</div>}
    </div>
  );
};

export default StatCard;
